module.exports = __webpack_public_path__ + "static/martay-b7452a27b40fee48e2a652aed7f19594.jpg";